import { PrimaryAnnotatedType } from '@/components/annotated-type';
import { HorizontalBarChart } from '@/components/bar-chart/horizontal';
import { ScrollGraphic, ScrollRoot, ScrollStep, ScrollSteps } from '@/components/microstory/scroll';
import { StoryText } from '@/components/microstory/text';
import { useNumberFormatting } from '@/utils/use-number-formatting';
import { t, Trans } from '@lingui/macro';
import { useState } from 'react';

type OnlineRisksChapter3Props = {
  data: OnlineRisksData['online_risks'];
};

export function OnlineRisksChapter3(props: OnlineRisksChapter3Props) {
  const { data } = props;
  const formatPercentage = useNumberFormatting('percent');

  const [visible, setVisible] = useState(false);

  const handleStepEnter = () => {
    setVisible(true);
  };

  return (
    <ScrollRoot>
      <ScrollGraphic>
        <HorizontalBarChart
          label={t({
            id: 'online-risks',
            message: '% of young people who see major risks to children online in',
          })}
          data={[
            {
              label: t({
                id: 'online-risks.chapter-3.chart-label-1',
                message: 'Talking to strangers',
              }),
              value: data.talking_to_strangers,
            },
            {
              label: t({
                id: 'online-risks.chapter-3.chart-label-2',
                message: "Meeting people in person who they've met online",
              }),
              value: data.meeting_people_they_met_online,
            },
            {
              label: t({ id: 'online-risks.chapter-3.chart-label-3', message: 'Being bullied' }),
              value: data.being_bullied,
            },
            {
              label: t({
                id: 'online-risks.chapter-3.chart-label-4',
                message: 'Being sexually harassed',
              }),
              value: data.being_sexually_harassed,
            },
          ]}
          formatValue={formatPercentage}
          visible={visible}
        />
      </ScrollGraphic>

      <ScrollSteps offset={0.7} onStepEnter={handleStepEnter}>
        <ScrollStep>
          <StoryText>
            <Trans id="online-risks.chapter-3.text-1">
              A majority of <PrimaryAnnotatedType>young people</PrimaryAnnotatedType> in nearly all
              countries surveyed see major risks for children of being online — from talking to
              strangers, to agreeing to meeting people in person whom they’ve met online, to being
              bullied or sexually harassed.
            </Trans>
          </StoryText>
        </ScrollStep>

        <ScrollStep>
          <StoryText>
            <Trans id="online-risks.chapter-3.text-2">
              Young women are especially likely to perceive risks to life online, especially for
              children.
            </Trans>
          </StoryText>
        </ScrollStep>
      </ScrollSteps>
    </ScrollRoot>
  );
}
